import { render, staticRenderFns } from "./ArchivedTab.htm?vue&type=template&id=408f45c7&scoped=true&"
import script from "./ArchivedTab.ts?vue&type=script&lang=js&"
export * from "./ArchivedTab.ts?vue&type=script&lang=js&"
import style0 from "../ChatRoomsTab.scss?vue&type=style&index=0&id=408f45c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408f45c7",
  null
  
)

export default component.exports